// ─── Le vocabulaire des états d'une échéance — UN SEUL endroit ────
// Il en existait trois copies (VueMois, FicheOccurrence, FicheLignePrevue),
// alors même qu'un commentaire annonçait « un second vocabulaire pour les
// mêmes états serait une divergence programmée ». Elle avait eu lieu.
//
// ⚠️ RÈGLE DU VERT (Cédric, 13/08) — le point important de ce fichier :
// **le vert ne se gagne pas tout seul.** Un mois n'est vert que lorsque
// l'utilisateur a déclaré « plus rien à rattacher ici ». Un mois dont le réel
// couvre le prévu est seulement COUVERT (🔵) : le montant y est, mais rien ne
// dit qu'une autre opération ne viendra pas s'y rattacher.
//
// C'est un renversement : avant, `realisee` prenait le vert dès que les
// chiffres tombaient juste. Le vert affirmait donc quelque chose que
// l'utilisateur n'avait jamais dit.

// GRILLE de Cédric (15/08) — « c'est plutôt "validé ce mois" que
// "verrouiller ce mois" » :
//   ✅ vert   : VALIDÉ par l'utilisateur — le seul état qu'on décide ;
//   🟠 orange : rattaché à au moins une opération, pas encore validé ;
//   🔴 rouge  : aucune opération rattachée.
// `ignoree`, `absente` et `avenir` restent : ils disent AUTRE chose que ce
// feu tricolore — « ne compte pas », « n'a pas eu lieu », « pas encore là ».
export const STATUTS = {
  // VALIDÉ par l'utilisateur. Plus de cadenas séparé : maintenant que le ✅
  // n'appartient qu'à cet état, il dit à lui seul « validé ».
  soldee:    { emoji: '✅', cle: 'finances.st_soldee', vert: true },
  // Rattaché mais NON VALIDÉ — couvert en entier ou en partie : les libellés
  // gardent la distinction, la couleur porte le même message.
  realisee:  { emoji: '🟠', cle: 'finances.st_couverte' },
  partielle: { emoji: '🟠', cle: 'finances.st_partielle' },
  manquante: { emoji: '🔴', cle: 'finances.st_manquante' },
  ignoree:   { emoji: '🔕', cle: 'finances.st_ignoree' },
  absente:   { emoji: '⛔', cle: 'finances.st_absente' },
  avenir:    { emoji: '🔮', cle: 'finances.st_avenir' },
};

export const statutDe = (o) => STATUTS[o?.statut] || STATUTS.avenir;

// « Clos » = VALIDÉ par l'utilisateur — et par lui seul. `ignoree` et
// `absente` ne sont pas des validations : elles disent que le mois ne compte
// pas, pas qu'on a fini de le remplir.
export const estClos = (o) => o?.statut === 'soldee';
